export class Parser {
  id: number;
  address: string;
  status: string;
}
